import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Input
} from '@angular/core';

@Component({
	selector: 'feedback-display-header',
	templateUrl: './feedback-display-header.component.html',
	styleUrls: ['./feedback-display-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule
	]
})
export class FeedbackDisplayHeaderComponent {
	@Input() public title: string = '';
}
